import { css } from '@emotion/core'
import { mediumUp } from 'Utils'
import theme from 'Theme'
const { mixins } = theme

export default () => css`
  .breadcrumbs-loading {
    height: 40px;
    margin-bottom: 20px;
    div {
      position: relative;
      top: 5px;
      height: 40px;
      width: auto;
      max-width: 400px;
      ${mixins.loadingLight(theme)}
    }
  }

  .main-loading {
    @media ${mediumUp} {
      display: flex;
    }
  }

  .filters-loading {
    display: none;

    @media ${mediumUp} {
      display: block;
      width: 22.5%;
      margin-right: 2.5%;
      height: 50vh;
    }

    div {
      position: relative;
      height: 50vh;
      width: 100%;
      ${mixins.loadingLight(theme)}
    }
  }

  .product-list-wrapper {
    width: 100%;
  }

  .product-card-load,
  .product-list-loading {
    ${mixins.loadingLight(theme)}
    height: 400px;
    @media ${mediumUp} {
      height: 500px;
    }
  }
`
